<template>
  <div>
    <top-bar heading="Edit Unit"></top-bar>
    <div class="container-fluid mt-3">
      <loading-spinner :loading="!loaded"></loading-spinner>
      <div class="row" v-if="loaded">
        <div class="col-lg-9 col-12">
          <b-card header="Unit Details">
            <b-card-body class="p-3">
              <div class="row mb-3">
                <div class="col">
                  <label class="control-label visible-ie8 visible-ie9" for="name">Unit Name</label>
                  <input
                          :class="{'form-control': true, 'is-invalid': errors.has('name')}"
                          v-validate="'required'"
                          data-vv-delay="500"
                          data-vv-as="Unit Name"
                          data-vv-name="name"
                          type="text"
                          placeholder="Unit Name"
                          name="name"
                          id="name"
                          v-model="unit.name"/>
                  <div class="invalid-tooltip d-block" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <label class="control-label visible-ie8 visible-ie9" for="description">Unit Description</label>
                  <vue-editor :class="{'is-invalid': errors.has('description')}"
                              v-validate="'required'"
                              data-vv-delay="500"
                              data-vv-as="Unit Description"
                              data-vv-name="description"
                              type="text"
                              placeholder="Unit Description"
                              name="description"
                              id="description"
                              v-model="unit.description"></vue-editor>
                  <div class="invalid-tooltip d-block" v-if="errors.has('description')">{{ errors.first('description') }}</div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <label class="control-label visible-ie8 visible-ie9" for="unit_published">Unit Status</label>
                  <select :class="{'form-control': true, 'is-invalid': errors.has('unit_published')}"
                          v-validate="'required'"
                          data-vv-delay="500"
                          data-vv-as="unit Status"
                          data-vv-name="unit_published"
                          type="text"
                          name="unit_published"
                          id="unit_published"
                          v-model="unit.published"
                          :disabled="!$auth.check('super_admin')">>
                    <option :value="0">Draft</option>
                    <option :value="1">Published</option>
                  </select>
                  <div class="invalid-tooltip d-block" v-if="errors.has('unit_published')">{{ errors.first('unit_published') }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <loading-button :loading="loading" @submit="saveUnit" block>Save Unit</loading-button>
                </div>
              </div>
            </b-card-body>
          </b-card>
          <h4>Modules</h4>
          <draggable :list="unit.modules" @change="changeModulesOrder">
            <div class="mb-3" v-for="module in unit.modules" :key="'module-card-' + module.id">
              <b-card-header v-b-toggle="'module-' + module.id" style="cursor: pointer; color: white;" :header-bg-variant="module.published ? 'primary' : 'danger'">
                <font-awesome-icon icon="arrows-alt" class="pointer mr-3 text-white"></font-awesome-icon>
                <b>Module {{module.ordinal }} - {{ module.name }}</b>
                <span class="float-right text-white"><font-awesome-icon icon="times" @click="deleteModule(module.id)"></font-awesome-icon></span>
              </b-card-header>
              <b-collapse :id="'module-' + module.id">
                <b-card-body class="p-3 bg-white">
                  <div class="row">
                    <div class="col">
                      <label class="control-label visible-ie8 visible-ie9" for="module_name">Module Name</label>
                      <input
                              :class="{'form-control': true, 'is-invalid': errors.has('module_name')}"
                              v-validate="'required'"
                              data-vv-delay="500"
                              data-vv-as="Module Name"
                              data-vv-name="module_name"
                              type="text"
                              placeholder="Module Name"
                              name="module_name"
                              id="module_name"
                              v-model="module.name"/>
                      <div class="invalid-tooltip d-block" v-if="errors.has('module_name')">{{ errors.first('module_name') }}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label class="control-label visible-ie8 visible-ie9" for="module_description">Module Description</label>
                      <b-form-textarea :class="{'form-control': true, 'is-invalid': errors.has('module_description')}"
                                       v-validate="'required'"
                                       data-vv-delay="500"
                                       data-vv-as="Module Description"
                                       data-vv-name="module_description"
                                       type="text"
                                       placeholder="Module Description"
                                       name="module_description"
                                       id="module_description"
                                       v-model="module.description"/>
                      <div class="invalid-tooltip d-block" v-if="errors.has('module_description')">{{ errors.first('module_description') }}</div>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col">
                      <label class="control-label visible-ie8 visible-ie9" for="module_duration">Module Duration</label>
                      <select :class="{'form-control': true, 'is-invalid': errors.has('module_duration')}"
                              v-validate="'required'"
                              data-vv-delay="500"
                              data-vv-as="Module Duration"
                              data-vv-name="module_duration"
                              type="text"
                              name="module_duration"
                              id="module_duration"
                              v-model="module.duration">
                        <option label="1 Week" :value="1">1 Week</option>
                        <option label="2 Weeks" :value="2">2 Weeks</option>
                        <option label="3 Weeks" :value="3">3 Weeks</option>
                        <option label="4 Weeks" :value="4">4 Weeks</option>
                        <option label="5 Weeks" :value="5">5 Weeks</option>
                        <option label="6 Weeks" :value="6">6 Weeks</option>
                        <option label="7 Weeks" :value="7">7 Weeks</option>
                      </select>
                      <div class="invalid-tooltip d-block" v-if="errors.has('module_duration')">{{ errors.first('module_duration') }}</div>
                    </div>
                    <div class="col">
                      <label class="control-label visible-ie8 visible-ie9" for="module_published">Module Status</label>
                      <select :class="{'form-control': true, 'is-invalid': errors.has('module_published')}"
                              v-validate="'required'"
                              data-vv-delay="500"
                              data-vv-as="Module Status"
                              data-vv-name="module_published"
                              type="text"
                              name="module_published"
                              id="module_published"
                              v-model="module.published">
                        <option :value="0">Draft</option>
                        <option :value="1">Published</option>
                      </select>
                      <div class="invalid-tooltip d-block" v-if="errors.has('module_published')">{{ errors.first('module_published') }}</div>
                    </div>
                  </div>
                  <div class="row mb-4">
                    <draggable :list="module.sections" class="col-12" @change="changeSectionsOrder">
                      <div :key="'section-' + section.id" v-for="section in module.sections">
                        <b-card-header class="mb-1" header-bg-variant="gray-200">
                          <font-awesome-icon icon="arrows-alt" class="pointer mr-3"></font-awesome-icon>
                          <span>{{module.ordinal}}.{{section.ordinal}}&nbsp;</span>
                          <span v-if="section.is_form">
                              <b>Assignment:</b>&nbsp;{{ section.form ? section.form.name : '(none selected)' }}&nbsp;
                            </span>
                          <span v-if="!section.is_form">{{section.name}}</span>
                          <span class="float-right">
                            <router-link :to="'/units/section/' + section.id" v-if="!section.is_form">
                              <font-awesome-icon icon="cog"></font-awesome-icon>
                            </router-link>
                            <a href @click.prevent="updateAssignment(section)" v-if="section.is_form">
                              <font-awesome-icon icon="cog"></font-awesome-icon>
                            </a>
                            <font-awesome-icon icon="times" class="pointer ml-2 text-danger" @click="deleteSection(section)"></font-awesome-icon>
                          </span>
                        </b-card-header>
                        <modal width="50%" height="auto" adaptive resizable :name="'assignment-modal-' + section.id" v-if="section.is_form">
                          <unit-assignment-selection-modal :form.sync="section.form" v-model="section.form_id" :section-id="section.id"></unit-assignment-selection-modal>
                        </modal>
                      </div>
                    </draggable>
                  </div>
                  <div class="row">

                    <!-- New Section -->
                    <div class="col-12">
                      <b-card-header class="mb-1" header-bg-variant="gray-200">
                        <a href @click.prevent="addSection(module)">
                          <font-awesome-icon icon="plus" class="text-orange mr-3"></font-awesome-icon>
                          <span>Add New Section</span>
                        </a>
                      </b-card-header>
                    </div>

                    <!-- New Assignment -->
                    <div class="col-12">
                      <b-card-header class="mb-1" header-bg-variant="gray-200">
                        <a href @click.prevent="addSection(module, true)">
                          <font-awesome-icon icon="plus" class="text-lime mr-3"></font-awesome-icon>
                          <span>Add New Assignment</span>
                        </a>
                      </b-card-header>
                    </div>

                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </draggable>
          <b-card-header header-bg-variant="lime" class="mb-3">
            <div @click="addModule" class="pointer">
              <font-awesome-icon icon="plus" class="text-orange mr-3"></font-awesome-icon>
              <b>Add New Module</b>
            </div>
          </b-card-header>
        </div>
        <div class="col d-lg-block d-none">
          <div class="row">
            <div class="col-12">
              <b-card header="Unit Codes" no-body>
                <b-card-body class="p-3">
                  <table class="table table-no-border">
                    <tr v-for="code in unit.codes" :key="'code-' + code.id">
                      <td>
                        <h4 class="bold">{{ code.name }}</h4>
                      </td>
                      <td class="text-center">
                        <a href @click.prevent="deleteCode(code)">
                          <font-awesome-icon icon="times" class="text-red"></font-awesome-icon>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <b-form-input type="text" v-model="newCode" placeholder="Unit code.."/>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <loading-button :loading="loading" :disabled="!newCode" block @submit="addCode">Add Code</loading-button>
                      </td>
                    </tr>
                  </table>
                </b-card-body>
              </b-card>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b-card header="Signoff Forms" no-body>
                <b-card-body class="p-3">
                  <v-select v-model="unit.forms" :options="forms" multiple label="name"></v-select>
                  <loading-button :loading="loading" block @submit="saveSignoffForms" class="mt-3">Save Signoff Forms</loading-button>
                </b-card-body>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import findIndex from 'lodash-es/findIndex'
import sortBy from 'lodash-es/sortBy'
import map from 'lodash-es/map'
import UnitAssignmentSelectionModal from '../../components/UnitAssignmentSelectionModal'

export default {
  name: 'EditUnit',
  components: { UnitAssignmentSelectionModal },
  data () {
    return {
      unit: {},
      loaded: false,
      loading: false,
      newCode: ''
    }
  },
  methods: {
    getUnit () {
      this.loaded = false
      this.axios.get('/courses/' + this.id, { params: { includes: 'codes,requisites,modules.sections.form,forms' } }).then(rsp => {
        rsp.data.modules = map(sortBy(rsp.data.modules, 'ordinal'), (module) => {
          module.sections = sortBy(module.sections, 'ordinal')
          return module
        })
        this.unit = rsp.data
        this.loaded = true
      })
    },
    saveUnit () {
      this.loading = true
      let unit = { ...this.unit }

      let payload = {
        id: unit.id,
        name: unit.name,
        description: unit.description,
        published: unit.published,
        ordinal: unit.ordinal,
        duration: unit.duration,
        modules: unit.modules.map(module => {
          return {
            id: module.id,
            name: module.name,
            ordinal: module.ordinal,
            description: module.description,
            published: module.published,
            duration: module.duration,
            notification_due: module.notification_due,
            sections: module.sections.map(section => {
              return {
                id: section.id,
                ordinal: section.ordinal,
                name: section.name,
                published: section.published,
                is_form: section.is_form,
                form_id: section.form_id
              }
            })
          }
        })
      }

      this.axios.put('/courses/' + this.id, payload).then(() => {
        this.loading = false
        this.getUnit()
        this.$snotify.success('Unit Saved')
      })
    },
    changeModulesOrder () {
      this.unit.modules = this.unit.modules.map((module, index) => {
        module.ordinal = index + 1

        return module
      })

      return true
    },
    changeSectionsOrder (e) {
      let module_index = findIndex(this.unit.modules, { id: e.moved.element.module_id })
      this.unit.modules[module_index].sections = sortBy(this.unit.modules[module_index].sections.map((section, index) => {
        section.ordinal = (index + 1)
        return section
      }), 'ordinal')

      return true
    },
    deleteModule (id) {
      let index = findIndex(this.unit.modules, { id })
      this.$swal({
        title: 'Are you sure?',
        text: 'This will delete the selected module!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.delete('/modules/' + id).then(() => {
            this.unit.modules.splice(index, 1)
            this.$snotify.success('Module Deleted')
          }).catch(err => this.$errorOut(err))
        }
      })
    },
    deleteSection (section) {
      this.$swal({
        title: 'Are you sure?',
        text: 'This will delete the selected section!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {

          let moduleIndex = findIndex(this.unit.modules, { id: section.module_id })
          let sectionIndex = findIndex(this.unit.modules[moduleIndex], { id: section.id })

          this.axios.delete('/sections/' + section.id).then(() => {
            this.$snotify.success('Section Deleted')
            this.unit.modules[moduleIndex].sections.splice(sectionIndex, 1)
          }).catch(err => this.$errorOut(err))
        }
      })
    },
    deleteCode (code) {
      const codeIdx = this.unit.codes.findIndex(el => el.id === code.id)
      if (codeIdx !== -1) this.unit.codes.splice(codeIdx, 1)

      this.axios.delete('/course_codes/' + code.id).then(() => this.$snotify.success('Code Deleted')).catch(err => this.$snotify.error(err.response.data.message))
    },
    addCode () {
      this.loading = true
      this.axios.post('/course_codes', { course_id: this.unit.id, name: this.newCode }).then(rsp => {
        this.newCode = ''
        this.loading = false
        this.$snotify.success('Unit Code Added')
        this.unit.codes.push(rsp.data)
      }).catch(err => this.$errorOut(err))
    },
    addSection (module, isForm = false) {
      let index = findIndex(this.unit.modules, { id: module.id })

      let params = {
        course_id: module.course_id,
        module_id: module.id,
        name: !isForm ? 'New Section' : 'Assignment',
        is_form: isForm,
        ordinal: this.unit.modules[index].sections.length + 1
      }

      this.axios.post('/sections', params).then(rsp => {
        this.unit.modules[index].sections.push(rsp.data.data)
        this.$snotify.success('Section Created')
      }).catch(err => this.$errorOut(err))
    },
    updateAssignment (section) {
      //this.$modal.show(UnitAssignmentSelectionModal, {value: section.form_id}, {width: '50%', resizable: true, adaptive: true, height: 'auto'});
      this.$modal.show('assignment-modal-' + section.id)
    },
    addModule () {
      let params = {
        course_id: this.unit.id,
        ordinal: this.unit.modules.length + 1,
        sections: [],
        name: 'New Module',
        published: 0,
        duration: 2
      }

      this.axios.post('/modules', params).then(rsp => {
        console.log(rsp.data)
        rsp.data.sections = []
        this.unit.modules.push(rsp.data)
        this.$snotify.success('Module Created')
      }).catch(err => this.$errorOut(err))
    },
    saveSignoffForms () {
      this.loading = true
      let params = {
        data: [...this.unit.forms].map(form => {
          return {
            course_id: this.unit.id,
            form_id: form.id
          }
        })
      }
      this.axios.put('/courses/' + this.unit.id + '/sync/forms', params).then(rsp => {
        this.$snotify.success('Signoff Forms Updated')
        this.unit.forms = rsp.data
        this.loading = false
      }).catch(err => this.$errorOut(err))
    }
  },
  computed: {
    forms () {
      return this.$store.state.signoffForms
    }
  },
  mounted () {
    this.getUnit()
    this.$store.dispatch('LOAD_ASSIGNMENTS', this)
    this.$store.dispatch('LOAD_SIGNOFF_FORMS', this)
  },
  metaInfo: {
    title: 'Edit Unit'
  },
  props: ['id']
}
</script>
